import { render, staticRenderFns } from "./OrdenesHistorialList.vue?vue&type=template&id=68431b4e&"
import script from "./OrdenesHistorialList.vue?vue&type=script&lang=js&"
export * from "./OrdenesHistorialList.vue?vue&type=script&lang=js&"
import style0 from "./OrdenesHistorialList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports